import "./index.css";

import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

// The old CARTO-basemap service worker is no longer registered; unregister any
// stale instance so returning visitors stop caching the removed /sw.js.
if ("serviceWorker" in navigator) {
  void (async () => {
    const registrations = await navigator.serviceWorker.getRegistrations();
    registrations.forEach((r) => r.unregister());
  })();
}

const root = document.getElementById("root");
if (root) {
  const tree = (
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  );
  // Prerendered routes (the city guides) ship with markup in #root and are
  // hydrated; every client-rendered route ships an empty #root and is mounted.
  if (root.firstElementChild) {
    hydrateRoot(root, tree);
  } else {
    createRoot(root).render(tree);
  }
}
